import { createFileRoute } from '@tanstack/react-router'
import { NewsShow } from '@/features/news/pages/news-show'

export const Route = createFileRoute('/_authenticated/news/$newsId/')({
  component: RouteComponent,
})

function RouteComponent() {
  const { newsId } = Route.useParams()
  return <NewsShow newsId={newsId} />
}
